import PropTypes from 'prop-types'

import {CheckIcon, ChevronRightIcon} from './icons'

import './questionRow.scss'

export const QUESTION_STATUS = {
  ANSWERED: 'answered',
  NEW: 'new'
}

/**
 * One pickable question (TK-3178), shared by the chapter picker's question
 * list and Review's "Add a story" drawer. The whole row is the button. The
 * status marker is a check for an answered question, an empty ring for an
 * unanswered one, or nothing at all when the caller leaves `status` unset.
 */
const QuestionRow = ({question, status = null, evergreen = false, onClick}) => (
  <button
    className={`ls-q-row${evergreen ? ' ls-q-row-evergreen' : ''}`}
    onClick={onClick}
    type='button'>
    {
      status === QUESTION_STATUS.ANSWERED &&
        <span className='ls-q-status ls-q-status-answered'>
          <CheckIcon size={13} strokeWidth={3} />
          <span className='ls-q-status-label'>Answered</span>
        </span>
    }
    {status === QUESTION_STATUS.NEW && <span aria-hidden='true' className='ls-q-status ls-q-status-new' />}
    <span className='ls-q-text'>{question}</span>
    <span className='ls-q-chevron'>
      <ChevronRightIcon />
    </span>
  </button>
)

QuestionRow.propTypes = {
  evergreen: PropTypes.bool,
  onClick: PropTypes.func,
  question: PropTypes.string,
  status: PropTypes.oneOf([QUESTION_STATUS.ANSWERED, QUESTION_STATUS.NEW])
}

export default QuestionRow
